import { useCallback, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { Container, LayoutStandard } from "components";
import { AuthorityConstants } from "constant";
import { UserService } from "services";
import { CreditStatus } from "types";
import { AppUtils, UserUtils } from "utils";

import ClientCreditStatusFilterBar, {
} from "./ClientCreditStatusFilterBar";
import ClientStatusFilterBar from "./ClientStatusFilterBar";
import { ClientStatusFilter } from "./ClientStatusFilterBar";
import ClientsList from "./list";
import TuttiClientsList from "./TuttiClientsList";

const ClientsPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [clientStatus, setClientStatus] = useState<ClientStatusFilter>("ALL");
  const [creditRequestStatus, setCreditRequestStatus] = useState<CreditStatus | undefined>();
  const isTuttiMode = useMemo(
    () => searchParams.get("source")?.toLowerCase() === "tutti",
    [searchParams],
  );

  const handleClientStatusChange = useCallback((status: ClientStatusFilter) => {
    setClientStatus(status);
    setCreditRequestStatus(undefined);
  }, []);

  const fetch = useCallback((page: number, search: string | undefined, source?: string) => {
    UserService.userClients({
      page,
      search,
      phase: "ALL",
      source,
      clientStatus: clientStatus === "ALL" ? undefined : clientStatus,
      creditRequestStatus,
      agent: false,
    });
  }, [clientStatus, creditRequestStatus]);

  const canViewTutti = UserUtils.hasAnyAuthority([
    AuthorityConstants.ROLE_TUTTI_R,
    AuthorityConstants.ROLE_TUTTI_C,
  ]);
  const canViewReserved = UserUtils.hasAuthority(AuthorityConstants.ROLE_CLT_RESERVED);
  const canViewBlacklisted = UserUtils.hasAuthority(AuthorityConstants.ROLE_CLT_BLACKLISTED);

  return (
    <LayoutStandard
      authority={AuthorityConstants.ROLE_CLT}
      title={AppUtils.composeTabTitle(t("clients.list.title"))}
    >
      <Container>
        {!isTuttiMode ? (
          <>
            <ClientStatusFilterBar
              value={clientStatus}
              onChange={handleClientStatusChange}
              allowAll
              canViewReserved={canViewReserved}
              canViewBlacklisted={canViewBlacklisted}
            />
            <ClientCreditStatusFilterBar
              clientStatus={clientStatus}
              value={creditRequestStatus}
              onChange={setCreditRequestStatus}
            />
            <ClientsList
              fetch={fetch}
              clientStatus={clientStatus}
              creditRequestStatus={creditRequestStatus}
            />
          </>
        ) : (
          <TuttiClientsList canViewTutti={canViewTutti} />
        )}
      </Container>
    </LayoutStandard>
  );
};

export default ClientsPage;
